import React from "react";
import PropTypes from "prop-types";

const AcmgPanelRight = ({ varsomeHost, setTermsModalOpen }) => {
  return (
    <div className="tw-inline-block tw-float-right">
      <div
        className="tw-inline-block"
        style={{
          marginRight: "1.2rem",
        }}
      >
        <a onClick={() => setTermsModalOpen(true)}>Terms of use</a>
      </div>
      <span className="tw-mr-5">
        <a
          href={`${varsomeHost}/about/germline-implementation/`}
          target="_blank"
        >
          Documentation
        </a>
      </span>
    </div>
  );
};

AcmgPanelRight.propTypes = {
  varsomeHost: PropTypes.string.isRequired,
  setTermsModalOpen: PropTypes.func.isRequired,
};

export default React.memo(AcmgPanelRight);
